// extracted by mini-css-extract-plugin
export default {"container_modal":"ModalUsuarioInfo_container_modal__lx-x7","topbar_item":"ModalUsuarioInfo_topbar_item__vlKPP","texto_link":"ModalUsuarioInfo_texto_link__wfca0"};